import { Input } from "@common/components";
import React from "react";

import { formatElapsedOverTotal } from "../../../../../common/components/waveform/waveform-geometry";
import { usePlayerState } from "../../../../../contexts/Player";
import { useProject } from "../../ProjectContext";

export const MixdownTime: React.FC = () => {
  const { project } = useProject();
  const { audio, currTime: _currTime, duration } = usePlayerState([
    "currTime",
    "audio",
    "duration",
  ]);
  const currTime = audio?.projectId === project?.id ? _currTime : 0;

  return (
    <Input
      size="xs"
      data-testid="mixdown-time"
      classNames={{ input: "w-24 text-md text-center bg-dark-900" }}
      value={formatElapsedOverTotal(currTime, duration)}
    />
  );
};
